import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'home',
    },
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('./view/home'),
    meta: {
      title: '首页',
    },
  },
  {
    name: 'cltb',
    path: '/cltb',
    component: () => import('./view/cltb'),
    meta: {
      title: '出栏填报',
    },
  },
  {
    name: 'cltb-edit',
    path: '/cltb-edit/:type/:id',
    component: () => import('./view/cltb-edit'),
    meta: {
      title: '出栏填报',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
